<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Logs</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item active">Logs
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-header">
                    <h4>Logs</h4>
                </div>

                <div class="card-body">
                    <form>
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="category">Search</label>
                                    <input name="search" id="category" class="form-control form-control"
                                           type="text"
                                           v-model="search">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="form-label">By Admin</label>
                                    <select v-model="adminId" id="" class="form-control">
                                        <option value="" selected>Select an Admin</option>
                                        <option v-for="admin in admins" :key="admin.id"
                                                :value="admin.id">
                                            {{ admin.first_name + " " + admin.last_name }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-12 mb-2">
                                <label>&nbsp;</label>
                                <br>
                                <button type="submit" @click.prevent="paginatedData"
                                        class="btn btn-primary glow mb-1 mb-sm-0">Apply Filter
                                </button>
                                <button type="reset" @click.prevent="resetFilters"
                                        class="btn btn-warning glow mb-1 mb-sm-0">
                                    Reset Filter
                                </button>
                            </div>
                        </div>
                    </form>
                    <vue-good-table
                        class="dataTable"
                        mode="remote"
                        :isLoading.sync="tableDataLoading"
                        :totalRows="totalRecords"
                        :pagination-options="paginationOptions"
                        :sort-options="sortingOptions"
                        @on-page-change="this.onPageChange"
                        @on-per-page-change="this.onPerPageChange"
                        styleClass="vgt-table"
                        :columns="columns"
                        :rows="allLogs"
                    >

<!--                        <div slot="emptystate" class="loading-container">-->
<!--                            <img src="/images/Spinner.svg" alt="">-->
<!--                        </div>-->
                        <template slot="table-row" slot-scope="props">
                             <span v-if="props.column.field === 'sn'">
                                    {{ serialNo(props) }}
                             </span>
                            <span v-else-if="props.column.field === 'admin'">
                               <a :href="props.row.admin ? route('admin.admins.show', props.row.admin.id) : ''">{{
                                       props.row.admin ? props.row.admin.first_name + ' ' + props.row.admin.last_name : ''
                                   }}</a>
                            </span>

                        </template>
                    </vue-good-table>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import PaginationMixin from "../../Shared/Mixins/PaginationMixin";
import {Link} from '@inertiajs/vue2'
import DeleteAlert from "../../Shared/Mixins/DeleteAlert";

export default {
    metaInfo: {title: 'Log'},
    props: ['admins', 'logs',],
    layout: Layout,
    components: {
      Link,
    },
    mixins: [
        DeleteAlert,
        PaginationMixin,
    ],
    data: () => ({
        search: '',
        adminId: '',
        errors: {},
        isLoadingFilter: false,
        allLogs: [],
        totalRecords: 0,
        serverParams: {
            page: 1,
            perPage: 10,
        },
        paginationOptions: {
            enabled: true,
            mode: 'pages',
            perPage: 10,
            perPageDropdown: [5, 10, 20, 50, 100, 200],
            dropdownAllowAll: false,
        },

        sortingOptions: {
            enabled: false,
        },
        columns: [
            {label: 'S/N', field: 'sn'},
            {label: 'Action', field: 'action'},
            {label: 'Admin', field: 'admin'},
            {label: 'Date', field: 'created_time'},
        ],
        tableDataLoading: false,
    }),
    mounted() {
        this.allLogs = this.logs.data;
        this.totalRecords = this.logs.total
    },
    methods: {
        async paginatedData() {
            try {
                let routeName = 'admin.admin-logs.index';

                let response = await axios.get(route(routeName), {
                    params: {
                        search: this.search,
                        admin_id: this.adminId,
                        page: this.serverParams.page,
                        per_page: this.serverParams.perPage,
                        api: true,
                    },
                    headers: {
                        "X-Requested-With": "XMLHttpRequest",
                    },
                });

                this.totalRecords = response.data.total;
                this.paginationOptions.perPage = response.data.per_page;
                this.serverParams.perPage = response.data.per_page;
                this.paginationOptions.setCurrentPage = response.data.page;
                this.allLogs = response.data.data
            } catch (e) {
                console.log(e);
            }
        },
        async resetFilters() {
            this.search = '';
            this.adminId = '';
            await this.paginatedData();
        },
    }
}
</script>
